<template lang="pug">
v-container(grid-list-md v-if="detail" class="menu")
    v-layout(wrap v-if="detail.additionalData && detail.additionalData.gaji")
        v-flex(lg2 md2 xs12 v-if="detail.additionalData.gaji.instanceId")
            v-text-field(dense v-model="detail.additionalData.gaji.instanceId" label="Kode Instansi" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
        v-flex(lg2 md2 xs12 v-if="detail.additionalData.gaji.treasuryId")
            v-text-field(dense v-model="detail.additionalData.gaji.treasuryId"  label="Kode Bendahara" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
    v-layout(wrap v-if="detail.additionalData && detail.additionalData.gaji")
        v-flex(lg2 md2 xs12 v-if="detail.additionalData.gaji.payrollId")
            v-text-field(dense v-model="detail.additionalData.gaji.payrollId" label="Id SI Gaji" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
        v-flex(lg2 md2 xs12 v-if="detail.additionalData.gaji.statusUpload")
            v-text-field(dense v-model="detail.additionalData.gaji.statusUpload" label="Status Upload" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
        v-flex(lg2 md2 xs12 v-if="detail.additionalData.gaji.statusPayroll")
            v-text-field(dense v-model="detail.additionalData.gaji.statusPayroll" label="Status Posting" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
    v-layout(wrap v-if="detail.additionalData && detail.additionalData.gaji")
        v-flex(lg11 md11 xs12 v-if="detail.additionalData.gaji.messageUpload")
            v-textarea(dense v-model="detail.additionalData.gaji.messageUpload" label="Keterangan Status Upload SI Gaji" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
        v-flex(lg11 md11 xs12 v-if="detail.additionalData.gaji.messagePayroll")
            v-textarea(dense v-model="detail.additionalData.gaji.messagePayroll" label="Keterangan Status Posting SI Gaji" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
    v-layout(wrap)
        v-flex(lg3 md3 xs12)
            f-decimalbox(v-model="amountDetail" label="Nominal" readonly :template="true")
        v-flex(lg2 md2 xs12)
            f-decimalbox(v-model="feeDetail" label="Biaya Admin" readonly :template="true")
        v-flex(lg3 md3 xs12)
            f-decimalbox(v-model="totalDetail" label="Total" readonly :template="true")
    v-layout(wrap v-if="listData && listData.length > 0")
        v-flex(lg12 md12 xs12)
            v-stepper(v-model="step")
                v-stepper-items
                    v-stepper-content(step="1")
                        v-data-table(
                            hide-default-footer 
                            :headers="headers" 
                            :items="listData" 
                            :items-per-page="itemsPerPage"
                            @page-count="pageCount = $event"
                            :page.sync="page"
                        )
                            template(v-slot:item.status="{item}")
                                v-chip(small v-if="item.status" :color="item.status == 'BERHASIL' ? 'info' : item.status == 'GAGAL' ? 'error' : 'warning'" dark) {{ item.status }}
                            template(v-slot:item.transactionId="{item}")
                                div(v-if="item.noArsip") {{ item.noArsip }}
                            template(v-slot:item.kmg="{item}")
                                div(v-if="item.additionalData && item.additionalData.gaji") {{ item.additionalData.gaji.kmgAmount | decimalformat }}
                            template(v-slot:item.name="{item}")
                                div(v-if="item.customerName") {{ item.customerName }}
                            template(v-slot:item.bankCode="{item}")
                                div(v-if="item.additionalData && item.additionalData.parameter && item.additionalData.parameter.bank") {{ item.additionalData.parameter.bank.bankId }}
                            template(v-slot:item.productDetail="{item}")
                                div(v-if="item.productCode") {{ item.productCode }}
                            template(v-slot:item.denom="{item}")
                                div(v-if="item.denomCode") {{ item.denomCode | decimalformat }}
                            template(v-slot:item.amount="{item}")
                                div {{ item.nilai | decimalformat }}
                            template(v-slot:item.fee="{item}")
                                div {{ item.biaya | decimalformat }}
                            template(v-slot:item.total="{item}")
                                div {{ item.total | decimalformat }}
                            template(v-slot:item.errorMessage="{item}")
                                div {{ item.errorMessage==null?item.keteranganError:item.errorMessage }}
                            template(v-slot:item.action="{item}")
                                v-layout(wrap justify-center class="menu-btn-sm")
                                    v-btn(color="primary" @click="show(item)" class="ma-1" v-if="item.additionalData && !(item.additionalData.productCode.includes('PAYROLL') || item.additionalData.productCode.includes('GAJI') || item.additionalData.productCode == 'TRF_INT')") Detail
                                        v-icon mdi-arrow-right-circle
                        div(class="text-xs-center")
                            v-pagination(v-model="page" :length="pageCount")
                    v-stepper-content(step="2")
                        v-container(grid-list-md v-if="transaction && transaction.journalDetail")
                            v-layout(wrap)
                                v-flex(lg6 md6 xs12 v-if="transaction.journalDetail.transactionId")
                                    v-text-field(dense v-model="transaction.journalDetail.transactionId" label="No. Transaksi Bank" readonly)
                                        template(v-slot:prepend)
                                            v-icon(color="primary") mdi-receipt
                                        template(v-slot:append)
                                            v-chip(small color="primary" class="my-1") {{transaction.journalDetail.settlementDate | dateformat}}
                        f-transaction-content(:productId="productId" :productGroup="productGroup" :content="content" :request="data" :transaction="transaction")
                        div(justify-center style="text-align: center;" class="ma-2 menu-btn")
                            v-btn(class="mx-1" @click="step = '1'") Kembali
                                v-icon mdi-arrow-left-circle
                                
</template>
<script>
export default {
    name: "FKasdaDetailTable",
    props: ["detail"],
    data() {
        return {
            headers: [
                {text: '', value: 'status', sortable: false, align: "center", width: "120px", class: "primary--text"},
                {text: 'No Pelanggan', value: 'customerId', sortable: false, width: "150px", class: "primary--text"},
                {text: 'Nama', value: 'name', sortable: false, width: "250px", class: "primary--text"},
                {text: 'Nominal', align: "right", value: 'amount', sortable: false, width: "150px", class: "primary--text"},
                {text: 'Biaya', align: "right", value: 'fee', sortable: false, width: "150px", class: "primary--text"},
                {text: 'Total', align: "right", value: 'total', sortable: false, width: "150px", class: "primary--text"},
                {text: 'Pesan', value: 'errorMessage', sortable: false, width: "250px", class: "primary--text"},
                {text: '', value: 'action', sortable: false, width: "150px"},
            ],
            listData: [],
            itemsPerPage: 5,
            criteria: "",
            pageCount: 0,
            page: 1,
            item: null,
            productId: "",
            productGroup: "",
            content: null,
            data: null,
            transaction: null,
            step: "1",
        }
    },
    mounted() {
        this.doInit(this.detail);
    },
    watch: {
        detail(val) {
            this.doInit(val);
        }
    },
    computed: {
        amountDetail() {
            if (this.listData && this.listData.length > 0) {
                return this.listData.map(m => m.nilai).reduce((a,b) => a + b)
            } else {
                return 0;
            }
        },
        feeDetail() {
            if (this.listData && this.listData.length > 0) {
                return this.listData.map(m => m.biaya).reduce((a,b) => a + b)
            } else {
                return 0;
            }
        },
        totalDetail() {
            if (this.listData && this.listData.length > 0) {
                return this.listData.map(m => m.total).reduce((a,b) => a + b)
            } else {
                return 0;
            }
        }
    },
    methods: {
        doInit(value){
            this.step = "1";
            this.setHeader();
            this.listData = value ? value.listDetail : [];
        },
        doReset(){
            this.itemsPerPage = 10;
            this.criteria = "";
            this.pageCount = 0;
            this.page = 1;
        },
        show(item){
            this.$emit("detail", item);
            this.item = item;
            if (this.item.additionalData) {
                this.productId = this.item.additionalData.productCode;
                this.productGroup = this.item.additionalData.productGroup;
                this.content = this.item.inquiryResponse;
                this.data = this.item.inquiryRequest;
                this.transaction = this.item.transactionResponse
            }
            this.step = "2";
        },
        setHeader() {
            if (this.detail && this.detail.additionalData) {
                if(this.detail.productCode == 'SP2D_PAYROLL' || this.detail.productCode == 'KASDA_PAYROLL'|| this.detail.productId == 'SI_GAJI_MULTI'){
                    this.headers = [
                        {text: '', value: 'status', sortable: false, align: "center", width: "120px", class: "primary--text"},
                        {text: 'No Rekening', value: 'customerId', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Nama', value: 'name', sortable: false, width: "250px", class: "primary--text"},
                        {text: 'Angsuran Kredit/Pembiayaan', align: "right", value: 'kmg', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Gaji Netto', align: "right", value: 'total', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Pesan', value: 'errorMessage', sortable: false, width: "250px", class: "primary--text"},
                        {text: '', value: 'action', sortable: false, width: "150px"},
                    ];
                } else if(this.detail.productCode == 'SP2D_MLT_TRF' || this.detail.productCode == 'KASDA_MLT_TRF' || this.detail.additionalData.productCode =='MLT_TRF_INT') {
                    this.headers = [
                        {text: '', value: 'status', sortable: false, align: "center", width: "120px", class: "primary--text"},
                        {text: 'Jenis Transaksi', value: 'productDetail', sortable: false, width: "100px", class: "primary--text"},
                        {text: 'Kode Bank', value: 'bankCode', sortable: false, width: "100px", class: "primary--text"},
                        {text: 'No Rekening', value: 'customerId', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Nama', value: 'name', sortable: false, width: "250px", class: "primary--text"},
                        {text: 'Nominal', align: "right", value: 'amount', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Biaya', align: "right", value: 'fee', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Total', align: "right", value: 'total', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Pesan', value: 'errorMessage', sortable: false, width: "250px", class: "primary--text"},
                        {text: 'No Arsip', value: 'transactionId', align: "center", sortable: false, width: "120px", class: "primary--text"},
                        {text: '', value: 'action', sortable: false, width: "150px"},
                    ];
                } else if(this.detail.additionalData.productGroup.includes('PURCHASE')) {
                    this.headers = [
                        {text: '', value: 'status', sortable: false, align: "center", width: "120px", class: "primary--text"},
                        {text: 'No Pelanggan', value: 'customerId', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Nama', value: 'name', sortable: false, width: "250px", class: "primary--text"},
                        {text: 'Denom', value: 'denom', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Nominal', align: "right", value: 'amount', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Biaya', align: "right", value: 'fee', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Total', align: "right", value: 'total', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Pesan', value: 'errorMessage', sortable: false, width: "250px", class: "primary--text"},
                        {text: '', value: 'action', sortable: false, width: "150px"},
                    ];
                } else if(this.detail.additionalData.productGroup.includes('PAYMENT')){
                    this.headers = [
                        {text: '', value: 'status', sortable: false, align: "center", width: "120px", class: "primary--text"},
                        {text: 'No Pelanggan', value: 'customerId', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Nama', value: 'name', sortable: false, width: "250px", class: "primary--text"},
                        {text: 'Nominal', align: "right", value: 'amount', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Biaya', align: "right", value: 'fee', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Total', align: "right", value: 'total', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Pesan', value: 'errorMessage', sortable: false, width: "250px", class: "primary--text"},
                        {text: '', value: 'action', sortable: false, width: "150px"},
                    ];
                }
            }
        },
    },
}
</script>